import md5 from 'js-md5';
const track = function(_custom){
	var params = {};
	//产品信息
	params.product='新专网数字经济';
	params.producttype='文献类';
	// params.reqtype='正常请求';
	//Document对象数据
	if (document) {
	    // params.domain = document.domain || ''; //获取域名
	    params.url = document.URL || '';       //当前Url地址
	    // params.pageTitle = document.title || '';		//标题
	    // params.referrer = document.referrer || '';  //上一跳路径
			// params.cookie = document.cookie || '';  //cookie
	}
	//Window对象数据
	// if (window && window.screen) {
	//     params.sh = window.screen.height || 0;    //获取显示屏信息
	//     params.sw = window.screen.width || 0;
	//     params.cd = window.screen.colorDepth || 0;
	// }
	//Window性能数据
	// if (window && window.performance) {
	//     params.navigation = window.performance.navigation.type || '';    
	// 		//获取导航到当前页面的方式
	// 		// type=0：表示当前页面是通过点击链接，书签和表单提交，或者脚本操作，或者在url中直接输入地址访问的。
	// 		// type=1: 表示当前页面是点击刷新或者调用Location.reload()方法访问的。
	// 		// type=2: 表示当前页面是通过历史记录或者前进后退按钮访问的。
	// 		// type=255: 其他方式访问的
	// 		params.timing = window.performance.timing.navigationStart || ''; 
	// 		//窗口结束上一个页面开始访问当前页面的时间戳
	// }
	//navigator对象数据
	if (navigator) {
	    // params.lang = navigator.language || '';    //获取所用语言种类
			params.useragentstr = navigator.userAgent || '';    //浏览器信息
	}
	//cookie数据
	if(this.$cookies.get('userinfo')){
		params.userid=this.$cookies.get('userinfo').userAccountID?this.$cookies.get('userinfo').userAccountID:'';
		params.username=this.$cookies.get('userinfo').username?this.$cookies.get('userinfo').username:'';
		params.usertype=this.$cookies.get('userinfo').usertype?this.$cookies.get('userinfo').usertype:'';
		// params.groupid=this.$cookies.get('userinfo').groupaccount?this.$cookies.get('userinfo').groupaccount:'';
		// params.groupname=this.$cookies.get('userinfo').groupName?this.$cookies.get('userinfo').groupName:'';
	}
	//对接后台验证数据
	params.browsetime=new Date().getTime();
	params.token=md5(params.url+'-'+params.browsetime);
	//解析自定义项
	if (_custom) {
	    for (var i=0;i<_custom.length;i++) {       //获取传递过来的自定义项
	        params[_custom[i][0]] = _custom[i][1];
	    }
	}
	if (typeof navigator.sendBeacon !== "function") { 
		// console.log(JSON.stringify(params));
		//拼接参数串
		var args = '';
		for (var i in params) {
		    // alert(i);
		    if (args != '') {
		        args += '&';
		    }
		    args += i + '=' + encodeURIComponent(params[i]);           //将所有获取到的信息进行拼接
		}
		// args='jsondata='+encodeURIComponent(JSON.stringify(params));
		//通过伪装成Image对象，请求后端脚本
		debugger;
		var img = new Image(1, 1);
		var src = process.env.NODE_ENV === 'development'? process.env.VUE_APP_TRACK_URL : window.SITE_CONFIG.trackUrl;
		src += '?' + args;
		img.src = src;
	}
	else{
		// console.log(JSON.stringify(params));
		// debugger;
		// var formData = new FormData();
		// for (var i in params) {
		//     formData.append(i,params[i]);          //将所有获取到的信息进行拼接
		// }
		navigator.sendBeacon(process.env.NODE_ENV === 'development'? process.env.VUE_APP_TRACK_URL : window.SITE_CONFIG.trackUrl, JSON.stringify(params));
	}
	
}

export default track